<template>

    <div class="wrapper-main page-container">

        <header-band
            :back="true"
            :blueCleanfox="true"
            :title="$t('login_email_web_header')"
            @eventBack="back"
        ></header-band>

        <login :emailProps="loginEmail"></login>

    </div>

</template>

<script>

import InputText from'@/components/inputs/InputText'
import Login from '@/components/loginFlow/Login'
import HeaderBand from '@/components/headers/HeaderBand'

import Storage from '@/helpers/storage'
import UserFlow from '@/modules/userFlow'
import SessionStorage from '@/helpers/sessionStorage'

export default {

    name: 'login-page',

    components: {InputText, Login, HeaderBand},

    computed: {
        loginEmail () {
            return SessionStorage.getItem('email')
        }
    },

    data() {

        return {
            provider: ''
        }

    },

    created() {

        UserFlow.setPage(this, 'login')

    },

    mounted() {

        if (this.$route.params && this.$route.params.provider) {

            this.provider = this.$route.params.provider

        }

    },

    methods: {

        back() {

            if (Storage.getItem('token')) {

                this.$router.push({path: '/add-inbox'})

            } else {

                this.$router.push({path: '/'})

            }
        }
    }
}

</script>

<style lang="scss" scoped>

.page-container {
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
}

</style>
